/** The player's chosen display name, remembered on this device only.
 * Storage may be blocked (private mode, policy); fall back to memory for the visit. */
export const NAME_KEY = "after-hours-name";
export const NAME_MAX = 24;
let memory: string | null = null;
const listeners = new Set<(name: string | null) => void>();

/** Same rules the server applies: trimmed, NFC, 1–24 code points, no control chars. */
export function cleanName(value: string): string | null {
  const name = value.trim().normalize("NFC");
  if (!name || [...name].length > NAME_MAX || /[\p{Cc}\p{Cf}]/u.test(name))
    return null;
  return name;
}

export function getSavedName(): string | null {
  try {
    const stored = globalThis.localStorage?.getItem(NAME_KEY);
    if (stored != null) return cleanName(stored) ?? memory;
  } catch {
    /* Storage blocked: use the in-memory name for this visit. */
  }
  return memory;
}

export function saveName(value: string): string | null {
  const name = cleanName(value);
  if (!name) return null;
  memory = name;
  try {
    globalThis.localStorage?.setItem(NAME_KEY, name);
  } catch {
    /* Remembered in memory only. */
  }
  for (const listener of listeners) listener(name);
  return name;
}

export function onNameChange(listener: (name: string | null) => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Test seam: forget the in-memory fallback. */
export function resetProfileMemory() {
  memory = null;
}
